export const BASE_URL = 'https://api.purelink.in/api/v1'